export const shariahReport = {
  businessScreening: "Business Screening",
  financialScreening: "Financial Screening",
  pass: "Pass",
  fail: "Fail",
  businessActivity: "Business Activity",
  interestSecurities: "Interest-bearing securities and assets",
  interestDebt: "Interest-bearing debt",
  compliantLabel: "Shariah compliant",
  compliantRange: "Less than 30%",
  nonCompliantLabel: "Non-shariah compliant",
  nonCompliantRange: "Greater than 30%",
  currencyUsd: "Currency in USD",
  displayPercent: "Percent",
  displayCurrency: "Currency",
  calculation: "Calculation",
  detailedReport: "Detailed Report",
  halal: "Halal",
  doubtful: "Doubtful",
  notHalal: "Not Halal",
  notQualified: "Not qualified",
  halalIncome: "Halal Income",
  doubtfulRevenue: "Doubtful Revenue",
  notHalalIncome: "Not Halal Income",
  otherIncome: "Other Income",
  grossSales: "Gross Sales",
  halalRevenue: "Halal Revenue",
  businessActivityDesc:
    "The combined value of Non Halal and Doubtful sources **should not exceed 5% of the Total Revenue** (Gross Sales + Other Income).",
  lastUpdated: "Last updated: {{date}}",
  interestSecuritiesDesc:
    "Total amount of interest-bearing securities and assets **should not exceed 30% of the market capitalization** of the company.",
  interestDebtDesc:
    "Interest-bearing debt, whether long-term or short-term debt **should not exceed 30% of the market capitalization** of the company.",
  shortTerm: "Short-term",
  longTerm: "Long-term",
  totalLabel: "Total",
  formulaTitle: "Not Halal Business Activity Percentage =",
  halalSalesIncome: "Halal Sales & Income",
  doubtfulSalesIncome: "Doubtful Sales & Income",
  nonHalalSalesIncome: "Non Halal Sales & Income",
  totalRevenue: "Total Revenue",
  totalInterestSecurities: "Interest-bearing securities and assets (total)",
  totalInterestDebt: "Total interest-bearing debt",
  halalRatingTitle: "Halal Rating",
  halalRatingAria: "Halal rating {{score}} out of 10",
  faq: {
    title: "Frequently asked questions",
    intro:
      "Quick answers about {{company}} ({{symbol}}). Current Akinda screening label: {{statusLabel}}.",
    statusUnknown: "Not yet classified",
    q1: "Is {{symbol}} a Shariah-compliant stock?",
    a1:
      "Akinda screens {{company}} ({{symbol}}) using Islamic finance criteria. The current classification is {{statusLabel}}. Screening is informational and not a fatwa; consult a qualified scholar for personal guidance.",
    q2: "Can Muslims buy shares of {{company}}?",
    a2:
      "Whether a Muslim may invest depends on your school of thought and the stock's Shariah classification. On Akinda, {{company}} ({{symbol}}) is currently labeled {{statusLabel}}. Always verify with your own research and advisors.",
    q3: "Where can I check the Shariah status of {{company}}?",
    a3:
      "You can view {{company}}'s Shariah status on this symbol page (ticker {{symbol}}), in the header, and on the Summary tab. The Akinda app shows the same screening when you search for {{symbol}}.",
    q4: "Why is {{company}} classified as {{statusLabel}}?",
    a4:
      "{{company}} ({{symbol}}) receives its label from Akinda's methodology: business activity (non-permissible revenue) and financial ratios (interest-bearing debt and assets) are compared to published thresholds. The result {{statusLabel}} reflects those screens at the time of the latest data.",
    q4Pending: "Why is {{company}}'s Shariah status not shown yet?",
    a4Pending:
      "Screening for {{company}} ({{symbol}}) may still be loading or awaiting data. The status will show as Halal, Doubtful, or Not halal once financials and business mix are fully processed. Refresh this page after a few minutes.",
    q5: "Can a halal stock like {{company}} become non-compliant?",
    a5:
      "Yes. {{company}} ({{symbol}}) can move from Halal to Doubtful or Not halal if revenue mix, debt, or impermissible income crosses Akinda's limits. Check {{symbol}} periodically—Akinda updates results when new filings arrive.",
  },
} as const;
